export default "__VITE_ASSET__KI8yc_tp__"